module.exports = __webpack_public_path__ + "static/media/ideologiq_intro_mediumquality.2fb742c1.mp4";